import { Box, Text } from "@chakra-ui/react";

const CampInstructores = () => {
  return (
    <Box>
      <Text fontWeight="semibold" textStyle="4xl">
        Instructores
      </Text>
      <Text pb="5">Esta vista se habilitará con más detalles en una siguiente iteración.</Text>
    </Box>
  );
};

export default CampInstructores;
